<template>
  <div class="radar_content">
    <iframe :src="src" width="100%" :height="height" frameborder="0" scrolling="auto"></iframe>
  </div>
</template>
<script>
export default {
  name: 'Radar',
  data () {
    return {
      height: '100%',
      src: ''
    }
  },
  mounted () {
    this.src = this.Global.getIframeUrl(this)
  }
}
</script>
<style scoped>
.radar_content{
  height:100%;
  /* margin-top: -80px; */
}
</style>
